import { FixedNavItem, NavItem } from '../types';

import { Permissions } from '../../../../../shared/utils/access-control/enums/permissions';
import { checkShouldShowBillings } from './helper';

export const NavItems: NavItem[] = [
  {
    key: 'sequence',
    route: '/sequence',
    text: 'Sequences',
    permission: Permissions.SEQUENCE_READ,
  },
  {
    key: 'tasks',
    route: '/tasks',
    text: 'Tasks',
    permission: Permissions.TASK_READ,
  },
  {
    key: 'unifiedInbox',
    route: '/conversations',
    text: 'Unified Inbox',
    permission: Permissions.UNIFIED_INBOX_READ,
  },
  {
    key: 'agency-client',
    route: '/clients',
    text: 'Client Management',
    permission: Permissions.CLIENT_READ,
  },
  {
    key: 'leads',
    route: '/leads',
    text: 'Lead Finder',
    permission: Permissions.LEAD_FINDER_READ,
  },
  // {
  //   key: 'v2-leads',
  //   route: '/v2/leads',
  //   text: 'Lead Finder v2',
  //   permission: Permissions.LEAD_FINDER_READ,
  // },
  {
    key: 'prospects',
    route: '/crm',
    text: 'CRM',
    permission: Permissions.PROSPECT_READ,
    // childRouteHasParentRoute: true,
    // subNavItems: [
    //   {
    //     key: 'list',
    //     route: '/prospects',
    //     text: 'List View',
    //     sameRouteAsParent: true,
    //   },
    //   {
    //     key: 'kanban',
    //     route: '/prospects/kanban',
    //     text: 'Kanban View',
    //   },
    // ],
  },
  {
    key: 'email-verifier',
    route: '/email-verifier',
    text: 'Email Verifier',
    permission: Permissions.PROSPECT_READ,
    showInfoOnDemo: false,
  },
  {
    key: 'email-accounts',
    route: '/email-accounts',
    text: 'Email Accounts',
    permission: Permissions.EMAIL_ACCOUNT_READ,
    subNavItems: [
      {
        key: 'domains',
        route: '/domains',
        text: 'Domains',
      },
      {
        key: 'inframail-ips',
        route: '/inframail-ips',
        text: 'Inframail IPs',
      },
    ],
  },
  {
    key: 'templates',
    route: '/templates',
    text: 'Templates',
    permission: Permissions.TEMPLATE_READ,
    showInfoOnDemo: false,
  },
  {
    key: 'inbox-radar',
    route: '/inbox-radar',
    text: 'Inbox Radar',
    permission: Permissions.INBOX_ANALYZER_READ,
  },
  {
    key: 'reports',
    route: '/reports',
    text: 'Analytics',
    permission: Permissions.REPORT_READ,
  },
  {
    key: 'billing',
    route: '/billing',
    text: 'Billing',
    permission: checkShouldShowBillings,
    showInfoOnDemo: false,
  },
  {
    key: 'setting',
    route: '/settings',
    text: 'Settings',
    permission: Permissions.SETTING_READ,
    showInfoOnDemo: false,
  },
];

export const FixedNavItems: FixedNavItem[] = [
  {
    key: 'email-insights',
    route: '/email-insights',
    text: '1:1 Email Insights',
    permission: Permissions.MAILBOX_EMAIL_READ,
  },
  {
    key: 'warmup',
    route: '/warmup',
    text: 'Email Warm-up',
    permission: Permissions.EMAIL_WARMUP_READ,
  },
  {
    key: 'referral',
    route: '',
    text: 'Refer A Friend',
    permission: Permissions.REFER_TAB_SHOW,
  },
  {
    key: 'growthHub',
    route: '/growth-hub',
    text: 'Growth Hub',
    permission: Permissions.GROWTH_HUB_TAB_SHOW,
  },
];
